import React from "react"
import { graphql, Link } from "gatsby"
import { Layout, Section, ContactButtons, ProjectCard, EntryRows, isPresentation } from "../components/Site"

const Hero = () => (
  <header>
    <div className="wrap">
      <div className="hero">
        <div>
          <div className="eyebrow">// R/Shiny engineer · full-stack developer</div>
          <h1>Pedro Coutinho Silva</h1>
          <p className="lead">
            15 years shipping software, <b>from client websites to Fortune 500 dashboards to validated apps for pharma</b>.
            Front-end at heart, happy anywhere in the stack.
          </p>
          <ContactButtons />
        </div>
        <div className="photo" role="img" aria-label="Pedro Coutinho Silva" />
      </div>
      <div className="stats">
        <div className="stat"><b>15 <em>yrs</em></b><span>shipping software</span></div>
        <div className="stat"><b>50<em>+</em></b><span>Fortune 500 projects</span></div>
        <div className="stat"><b>200<em>+</em></b><span>GitHub stars</span></div>
        <div className="stat"><b>25<em>+</em></b><span>talks, panels and webinars</span></div>
      </div>
    </div>
  </header>
)

export default ({ data }) => {
  const featured = data.projects.nodes
    .filter(node => node.frontmatter.featured)
    .sort((a, b) => a.frontmatter.featured - b.frontmatter.featured)
  const talks = data.articles.nodes.filter(isPresentation).slice(0, 5)
  const writing = data.articles.nodes.filter(node => !isPresentation(node)).slice(0, 3)

  return (
    <Layout title="Home" hero={<Hero />}>
      <Section id="projects" n="01" title="Projects">
        <div className="grid">
          {featured.map((node, i) => (
            <ProjectCard key={node.id} node={node} feature={i < 3} />
          ))}
        </div>
        <Link className="more" to="/projects">All projects →</Link>
      </Section>

      <Section id="talks" n="02" title="Talks and workshops">
        <EntryRows nodes={talks} />
        <Link className="more" to="/articles">All talks →</Link>
      </Section>

      <Section id="writing" n="03" title="Writing">
        <EntryRows nodes={writing} />
        <Link className="more" to="/articles#writing">All articles →</Link>
      </Section>

      <Section id="about" n="04" title="About">
        <div className="about">
          <div>
            <p>
              Hi! I'm Pedro, a Portuguese developer based in Warsaw. I've worked as a backend, frontend and
              full-stack developer and as a project lead.
            </p>
            <p>
              Today I'm a Principal Data Scientist at Jumping Rivers, where I lead client R and Shiny work and the
              development of the Litmus validation framework. Before that I spent six years at Appsilon.
            </p>
            <p>I like making data apps that are fast, good-looking and easy to trust.</p>
          </div>
          <div>
            <div className="g">R &amp; Shiny</div>
            <div className="chips">
              <span className="chip key">R / Shiny</span>
              <span className="chip">R packages</span><span className="chip">Quarto</span><span className="chip">SQL</span>
            </div>
            <div className="g">Front-end</div>
            <div className="chips">
              <span className="chip">JavaScript</span><span className="chip">React</span>
              <span className="chip">CSS / SASS</span><span className="chip">UI / UX</span>
            </div>
            <div className="g">Also</div>
            <div className="chips">
              <span className="chip">Python</span><span className="chip">Docker</span>
              <span className="chip">AWS</span><span className="chip">AI coding agents</span>
            </div>
          </div>
        </div>
      </Section>
    </Layout>
  )
}

export const query = graphql`
  query {
    projects: allMarkdownRemark(filter: { fileAbsolutePath: { regex: "/content/blog/" } }) {
      nodes {
        id
        excerpt(pruneLength: 160)
        frontmatter {
          title
          tags
          link
          repo
          featured
        }
      }
    }
    articles: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/content/articles/" } }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      nodes {
        id
        frontmatter {
          title
          tags
          link
          date(formatString: "MMM YYYY")
        }
      }
    }
  }
`
